/**
 * Route constants for auth-shell application
 * All route paths should be defined here to avoid hardcoded strings
 */
export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_EMAIL: '/forgot-email',
  CALLBACK: '/callback',
  LOADING: '/loading',
  SUCCESS: '/success',
  /** Marketing / value proposition before account creation */
  REGISTER: '/register',
  /** Account creation wizard (placeholder route until implemented) */
  REGISTER_CREATE_ACCOUNT: '/register/create-account',
  /** Registration complete success screen */
  REGISTER_SUCCESS: '/register/success',
  /** Post-registration NPS feedback */
  REGISTER_FEEDBACK: '/register/feedback',
  /** Download app screen with QR code */
  DOWNLOAD_APP: '/register/download-app',
} as const;

export type RoutePath = typeof ROUTES[keyof typeof ROUTES];
